import dayjs from 'dayjs';
import { classApi } from '@/api';

const dayWeek = ['日', '一', '二', '三', '四', '五', '六'];

export default {
  mounted() {
    this.$store.dispatch('globalConfig/getData');
  },
  computed: {
    globalConfig() {
      return this.$store.state.globalConfig.data;
    },
    countClass() {
      return row => {
        if (row.class_count < row.class_size) return 'row-blue';
        if (row.class_count === row.class_size) return 'row-yellow';
        if (row.class_count > row.class_size) return 'row-red';
        return '';
      };
    },
    countClassRes() {
      return row => {
        if (row.reserved_sign_up_count < row.reserved_count) return 'row-blue';
        if (row.reserved_sign_up_count === row.reserved_count) return 'row-yellow';
        return '';
      };
    },
    countClassMin() {
      return row => {
        if (row.minister_sign_up_count < this.globalConfig.minister_quota) return 'row-blue';
        if (row.minister_sign_up_count === this.globalConfig.minister_quota) return 'row-yellow';
        return '';
      };
    }
  },
  filters: {
    lastName(fullName = '') {
      if (!fullName) return '';
      const arr = fullName.split('/');
      return arr[arr.length - 1];
    },
    classStatus(row) {
      if (row.audit_status === 2) {
        // 审核通过的展示发布状态
        return row.publish_status_label;
      }
      return row.audit_status_label;
    },
    courseStatus(row) {
      if (row.sign_up_status === 3) {
        // 报名结束的展示上课状态
        return row.class_phase_label;
      }
      return row.sign_up_status_label;
    },
    teacherFilter(value) {
      return (value || []).map(item => item.real_name).join(',');
    },
    classPeriodic(value) {
      if (!value) return '无';
      return value
        .split(',')
        .filter(key => (key !== '' ? key : false))
        .map(key => dayWeek[key])
        .join('，');
    }
  },
  methods: {
    classPeriodic(value) {
      if (!value) return '无';
      const arr = value.split(',').filter(key => (key !== '' ? key : false));
      if (arr[0] === '0') {
        arr.shift();
        arr.push(0);
      }
      return arr.map(key => dayWeek[key]).join('，');
    },
    classTimeSp(row) {
      let str = '无';
      if (!row.first_class_start_time || !row.last_class_end_time) return str;
      if (row.class_mode === 3) {
        if (!Array.isArray(row.mode_class_time) || row.mode_class_time[0].length !== 3) return str;
        str = row.mode_class_time
          .map(
            item =>
              `星期${dayWeek[dayjs(item[0]).day()]} <span style="color: #3a8ee6">${dayjs(item[0]).format(
                'HH:mm'
              )}-${dayjs(item[1]).format('HH:mm')}</span> ${item[2]}`
          )
          .join('<br />');
      } else {
        str = `星期${this.classPeriodic(row.class_periodic)} <span style="color: #3a8ee6">${dayjs(
          row.first_class_start_time
        ).format('HH:mm')} - ${dayjs(row.last_class_end_time).format('HH:mm')}</span> ${
          Array.isArray(row.classroom) ? row.classroom[0] : ''
        }`;
      }
      return str;
    },
    classTimeSpTeam(row) {
      let str = '无';
      if (!row.first_class_start_time || !row.last_class_end_time) return str;
      if (row.class_mode === 3) {
        if (!Array.isArray(row.mode_class_time) || row.mode_class_time[0].length !== 3) return str;
        str = row.mode_class_time
          .map(
            item =>
              `星期${dayWeek[dayjs(item[0]).day()]} <span style="color: #3a8ee6">${dayjs(item[0]).format(
                'HH:mm'
              )}-${dayjs(item[1]).format('HH:mm')}</span>}`
          )
          .join('<br />');
      } else {
        str = `星期${this.classPeriodic(row.class_periodic)} <span style="color: #3a8ee6">${dayjs(
          row.first_class_start_time
        ).format('HH:mm')} - ${dayjs(row.last_class_end_time).format('HH:mm')}</span>`;
      }
      return str;
    },
    getHdEnum(classInfTable) {
      if (this.tableHeader.length) return;
      Promise.all([
        classApi.auditStatus(),
        classApi.publishStatus(),
        classApi.signUpStatus(),
        classApi.classPhase()
      ]).then(values => {
        this.tableHeader = classInfTable.map(item => {
          const tmp = item;
          if (tmp.value === 'class_status') {
            tmp.headerSlot.select = [
              ...values[0].data
                .filter(curItem => {
                  // 去除审核通过和审核未通过
                  if (curItem.value === 2 || curItem.value === 3) return false;
                  return curItem;
                })
                .map(cur => ({ value: `audit_status-${cur.value}`, label: cur.label }))
                .reverse(),
              ...values[1].data.map(cur => ({ value: `publish_status-${cur.value}`, label: cur.label }))
            ];
          }
          if (tmp.value === 'sign_up_status') {
            tmp.headerSlot.select = values[2].data;
          }
          if (tmp.value === 'class_phase') {
            tmp.headerSlot.select = values[3].data;
          }
          return tmp;
        });
        this.$nextTick(() => {
          if (this.$refs.setTableHd) this.$refs.setTableHd.init();
        });
      });
    }
  }
};
